import { Dispatch } from "redux";
import { Action } from "redux-actions";
import * as store from "store2";
import Constants from "./constants";
import ILocalSettingsState from "./state";

const saveLocalSettings =
  (localSettings: ILocalSettingsState) => (dispatch: Dispatch) => {
    store.set(Constants.LOCAL_STORAGE_KEY, localSettings)
    dispatch(createSaveLocalSettingsSuccess(localSettings));
  };

const createSaveLocalSettingsSuccess = (
  localSettings: ILocalSettingsState
): Action<ILocalSettingsState> => ({
  payload: localSettings,
  type: Constants.SAVE_LOCAL_SETTINGS_SUCCESS,
});

export default {
  saveLocalSettings,
};



// WEBPACK FOOTER //
// ./src/redux/modules/localSettings/actions.ts